/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseAutoAction } from '../../models/api-response-auto-action';
import { AutoAction } from '../../models/auto-action';

export interface UpdateSpecificDefaultAction$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: {
'mediaList': Array<Blob>;
'autoAction': AutoAction;
}
}

export function updateSpecificDefaultAction(http: HttpClient, rootUrl: string, params: UpdateSpecificDefaultAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAutoAction>> {
  const rb = new RequestBuilder(rootUrl, updateSpecificDefaultAction.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAutoAction>;
    })
  );
}

updateSpecificDefaultAction.PATH = '/v1/api/ui/auto-actions/media';
